import Sidebar from '@templates/Sidebar';
import SidebarMobile from '@templates/SidebarMobile';
import Header from '@templates/Header';
import { Outlet } from 'react-router-dom';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import SvgIcons from '@modules/SvgIcons';
import DubzIcon from '@modules/DubzIcon';
import ChangelogModal from '@/components/modules/changelog/ChangelogModal';
// import { Bounce, ToastContainer } from 'react-toastify';
import Providers from './providers';

export default function Layout() {
  return (
    <>
      <div className="flex w-full flex-row relative bg-transparent">
        <div className="h-screen bg-transparent">
          <Sidebar />
        </div>
        <div className="w-full flex flex-col max-sm:m-0 overflow-hidden h-screen relative bg-transparent">
          <Header />
          <div className="w-full overflow-y-auto h-[calc(100%-92px)] md:h-full bg-white dark:bg-blackFont-900 mx-auto scrollNone pb-8 mt-0">
            <div className="w-full h-[10px] bg-white dark:bg-blackFont-900"></div>
            <Outlet />
          </div>
          <SidebarMobile />
        </div>
      </div>
      <Tooltip id="my-tooltip" />
      <Tooltip id="my-tooltip-click" openOnClick={true} />
      <SvgIcons />
      <ChangelogModal />
      {/* <DubzIcon /> */}
      {/* <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={true}
          closeOnClick={true}
          rtl={false}
          draggable
          transition={Bounce}
          stacked={window.innerWidth > 768 ? true : false}
          icon={false}
          closeButton={false}
          style={{
            top: '16px', // فاصله از بالا
            left: '50%',
            transform: 'translateX(-50%)',
            width: '90%', // برای موبایل بهتر
            // maxWidth: "300px", // جلوگیری از بزرگ‌تر شدن از این مقدار
          }}
        /> */}
    </>
  );
}
